import { SETUP_ACCOUNT_FORM_FIELDS } from './reseller.constants';

export const getDefaultValuesInitialized = () => {
  return Object.values(SETUP_ACCOUNT_FORM_FIELDS).reduce((acc, field) => {
    return { ...acc, [field.name]: field.defaultValue };
  }, {});
};
